import { IPayloadAction } from '../session/session.actions';

export const PollingActions = {
  BEGIN_POLLING: '[Polling] Begin Polling',
  END_POLLING: '[Polling] End Polling',
};

export class BeginPolling implements IPayloadAction {
  readonly type = PollingActions.BEGIN_POLLING;
}

export class EndPolling implements IPayloadAction {
  readonly type = PollingActions.END_POLLING;
}
